exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stripedBackground {\n  background: repeating-linear-gradient(180deg, #F1F1F1, #F1F1F1 48px, #F9F9F9 48px, #F9F9F9 96px); }\n\n.productos {\n  margin: 25px 0 0 10px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  width: 50%; }\n\n.productoItem {\n  margin-bottom: 5px; }\n\n.custom-error {\n  font-size: 12px;\n  color: #ff6e40;\n  transform: translateY(-2px);\n  transition: all 0.2s ease;\n  opacity: 0;\n  display: block; }\n  .custom-error.show-error {\n    transform: translateY(5px);\n    opacity: 1; }\n\n.custom-input-error {\n  font-size: 12px;\n  color: #ff6e40;\n  transform: translateY(-25px);\n  transition: all 0.2s ease;\n  opacity: 0;\n  display: block; }\n  .custom-input-error.show-error {\n    transform: translateY(-15px);\n    opacity: 1; }\n\n.back-gray {\n  background-color: #eeeeee; }\n\n.back-white {\n  background-color: white; }\n\n.fillScreen {\n  width: 97%;\n  max-width: 1366px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/permisos-detail/permisos-detail.component.scss
// module id = ../../../../../src/app/components/abm/permisos-detail/permisos-detail.component.scss
// module chunks = 0